import React from "react";

const TwitterIcon = () => (
  <svg width="24" height="24" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="15" cy="15" r="14.5" stroke="#fff" />
    <path
      d="m7.806 7.847 5.88 7.863-5.917 6.393H9.1l5.181-5.597 4.187 5.597H23l-6.212-8.305 5.509-5.95h-1.332l-4.772 5.154-3.855-5.155H7.806Zm1.958.981h2.083l9.194 12.294H18.96L9.764 8.828Z"
      fill="#fff"
    />
  </svg>
);

export default TwitterIcon;
